import { Box, Card, styled } from "@mui/material";

export const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "60px",
  "& .TableHeadWrapper": {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: "20px",
    "& .BtnWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "left",
      gap: "10px",
      flex: "1",
      "@media screen and (max-width:600px)": {
        flexWrap: "wrap",
      },
      "& button": {
        backgroundColor: "transparent",
        border: "1px solid" + theme.palette.primary.main,
        color: theme.palette.primary.main,
        "&.Active": {
          backgroundColor: theme.palette.primary.main,
          color: "#ffffff",
        },
        "@media screen and (max-width:600px)": {
          width: "calc(100% / 2 - 5px)",
        },
        "&:focus": {
          outline: "0",
        },
      },
    },
  },
}));
export const BoxMainWrapper = styled(Box)(({ theme }) => ({
  "& .DataGridWrapper": {
    "& .DataTableWrapper": {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: "7px 7px 7px 7px",
      "&.PaginationHide .MuiDataGrid-footerContainer": {
        display: "none",
      },
    },
    "& .MuiDataGrid-main": {
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: theme.palette.mode === "dark" ? "#FFFFFF33" : "#2A3547",
        borderRadius: "0",
        "& .MuiDataGrid-columnSeparator": {
          color: "#8F8F8F",
          visibility: "visible",
        },
        "& .MuiDataGrid-columnHeadersInner": {
          flex: "1",
          '& div[role="row"]': {
            flex: "1",
            width: "100%",
            "& .MuiDataGrid-columnHeader": {
              outline: "none !important",
              paddingLeft: "18px",
              paddingRight: "18px",
              "& .MuiDataGrid-columnHeaderTitleContainer": {
                "& .MuiDataGrid-iconButtonContainer": {
                  display: "none",
                },
              },
            },
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "14px",
            color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
            fontWeight: 600,
          },
        },
      },
      "& .MuiDataGrid-virtualScroller": {
        overflowX: { xs: "auto", sm: "hidden" },
        "&::-webkit-scrollbar-track": {
          borderRadius: "10px",
          backgroundColor: `${theme.palette.text.primary}0d`,
        },
        "&::-webkit-scrollbar": { width: "8px", backgroundColor: "transparent" },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "10px",
          WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
          backgroundColor: theme.palette.primary.main,
        },
        "& .MuiDataGrid-virtualScrollerContent": {
          height: "calc(100vh - 295px) !important",
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100%",
            "@media screen and (max-width:600px)": {
              width: "auto",
            },
            "& .MuiDataGrid-row": {
              boxShadow: "none",
              minHeight: "70px !important",
              width: "100%",
            },
            '& div[role="row"]': {
              cursor: "pointer",
              borderBottom: `2px solid ${theme.palette.divider}`,
              width: "100%",
              "&:last-of-type": { borderWidth: "1px" },
              "& .MuiDataGrid-cell": {
                minHeight: "70px !important",
                flex: 1,
                paddingLeft: "18px",
                paddingRight: "18px",
                "&:last-of-type": {
                  display: "none",
                  "@media screen and (max-width:600px)": {
                    display: "flex",
                  },
                },
                "&.MuiDataGrid-cell--withRenderer": {
                  "&:last-of-type": {
                    display: "flex",
                  },
                },
                "&:focus-within": { outline: "none" },
                "& .MuiDataGrid-cellContent": {
                  color: theme.palette.text.primary,
                  fontWeight: 600,
                },
              },
            },
          },
        },
      },
    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "center",
      "& .MuiTablePagination-root": {
        "& .MuiToolbar-root": {
          "& .MuiTablePagination-selectLabel": {
            marginBottom: "0",
          },
          "& .MuiTablePagination-displayedRows": {
            marginBottom: "0",
          },
        },
      },
    },
  },
  "& .NotFoundWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 292px)",
    "& h5": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "16px",
    },
  },
}));
export const NewQueryPopupStyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "1000px",
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "38px 25px 25px",
  "@media screen and (max-width:1200px)": {
    width: "90%",
    padding: "40px 15px 10px",
  },
  "& .closeBtn": {
    width: "24px",
    height: "24px",
    backgroundColor: "transparent",
    padding: "10px !important",
    position: "absolute",
    top: "12px",
    right: "12px",
    minWidth: "0",
    "&:focus": {
      border: "none",
      outline: "none",
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#fff",
      "& svg": {
        fill: theme.palette.primary.main,
      },
    },
  },
  "& .HeadContentWrapper": {
    display: "flex",
    justifyContent: "space-between",
    "@media screen and (max-width: 600px)": {
      alignItems: "center",
    },
    "& .ContentWrapper": {
      "& h2": {
        fontSize: "22px",
        marginBottom: "12px",
        color: theme.palette.text.primary,
        fontWeight: 600,
      },
      "& p": {
        fontSize: "14px",
        marginBottom: "16px",
        color: theme.palette.text.primary,
      },
    },
  },
  "& .BodyContentWrapper": {
    "& .FormWrapper": {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      "& .LoaderText": {
        color: theme.palette.text.primary,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "16px 0",
      },
      "& .FieldBlock": {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        "& .FieldLabelRow": {
          display: "flex",
          alignItems: "center",
          gap: "6px",
          "& .FieldLabel": {
            fontSize: "13px",
            fontWeight: 600,
            color: theme.palette.text.secondary,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          },
          "& .TooltipIcon": {
            fontSize: "16px",
            color: theme.palette.text.disabled,
            cursor: "pointer",
            "&:hover": { color: theme.palette.primary.main },
          },
        },
      },
      "& .MuiFormControl-root": {
        width: "100%",
        "& label": {
          marginBottom: "0",
        },
      },
      "& .StartBtn": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "10px 24px",
        gap: "8px",
        alignSelf: "flex-end",
        minWidth: "120px",
        "&:focus": { outline: "0" },
        "& .LoaderWrapper": {
          width: "20px !important",
          height: "20px !important",
          color: "#ffffff",
        },
      },
    },
  },
}));
export const ContentScoreHeaderStyle = styled(Card)(({ theme }) => ({
  padding: "16px 16px 16px 16px",
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none !important",
  "& .ContentWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "15px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& h2": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      lineHeight: 1,
      fontWeight: 700,
      fontSize: "24px",
    },
    "& .BtnWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "8px",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
      },
      "& .QueryBtn": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "6px 16px",
        gap: "8px",
        "@media screen and (max-width:600px)": {
          width: "100%",
          padding: "6px 22px",
        },
        "&:focus": {
          outline: "0",
        },
      },
    },
  },
}));
